module.exports = __webpack_public_path__ + "static/icon_domestic_orange-ca86158c5f6ec6459f1f810e0f58a378.png";